import * as React from "react";
import { SpsPageTitle, SpsPageSubtitle, SpsCard } from "../index";
export const SpsPageTitlePropTypes = SpsPageTitle['propTypes'];
export class SpsPageTitleBasic extends React.Component<{"data-testid": any}> {
    static reactLive = {
        code: `
            <SpsCard>
            <SpsPageTitle>Cabela's Purchase Order #123456789012</SpsPageTitle>
            </SpsCard>
        `
    };

    render() {
        const { "data-testid": testId } = this.props;
        return (
            <SpsCard>
                <SpsPageTitle data-testid={testId}>Cabela's Purchase Order #123456789012</SpsPageTitle>
            </SpsCard>
        );
    }
}

export class SpsPageTitleWithIcon extends React.Component<{"data-testid": any}> {
    static reactLive = {
        code: `
            <SpsCard>
                <SpsPageTitle>
                  <i className="sps-icon sps-icon-exclamation-circle red200" aria-hidden="true"></i>
                  Cabela's Purchase Order #123456789012
                </SpsPageTitle>
            </SpsCard>
        `
    };

    render() {
        const { "data-testid": testId } = this.props;
        return (
            <SpsCard>
                <SpsPageTitle data-testid={testId}>
                  <i className="sps-icon sps-icon-exclamation-circle red200" aria-hidden="true"></i>
                  Cabela's Purchase Order #123456789012
                </SpsPageTitle>
            </SpsCard>
        );
    }
}

export class SpsPageTitleWithSubtitle extends React.Component<{"data-testid": any}> {
    static reactLive = {
        code: `
            <SpsCard>
            <SpsPageTitle>
                 Cabela's Purchase Order #123456789012
                 <SpsPageSubtitle>MacNeil Automotive Parts</SpsPageSubtitle>
                </SpsPageTitle>
            </SpsCard>
        `
    };

    render() {
        const { "data-testid": testId } = this.props;
        return (
            <SpsCard>
                <SpsPageTitle data-testid={testId}>
                 Cabela's Purchase Order #123456789012
                 <SpsPageSubtitle>MacNeil Automotive Parts</SpsPageSubtitle>
                </SpsPageTitle>
            </SpsCard>
        );
    }
}


export class SpsPageTitleSubtitleAndSubIcon extends React.Component<{"data-testid": any}> {
    static reactLive = {
        code: `
            <SpsCard>
            <SpsPageTitle>
              Cabela's Purchase Order #123456789012
              <SpsPageSubtitle>Cabela's
                <i className="sps-icon sps-icon-outgoing"></i>
                MacNeil Automotive Parts
              </SpsPageSubtitle>
            </SpsPageTitle>
            </SpsCard>
        `
    };

    render() {
        const { "data-testid": testId } = this.props;
        return (
            <SpsCard>
            <SpsPageTitle data-testid={testId}>
              Cabela's Purchase Order #123456789012
              <SpsPageSubtitle>Cabela's
                <i className="sps-icon sps-icon-outgoing"></i>
                MacNeil Automotive Parts
              </SpsPageSubtitle>
            </SpsPageTitle>
            </SpsCard>
        );
    }
}

export class SpsPageTitleIconSubtitleSubIcon extends React.Component<{"data-testid": any}> {
    static reactLive = {
        code: `
            <SpsCard>
            <SpsPageTitle>
                <i aria-hidden="true" className="sps-icon sps-icon-exclamation-circle red200"></i>
                Cabela's Purchase Order #123456789012
                <SpsPageSubtitle>Cabela's
                  <i aria-hidden="true" className="sps-icon sps-icon-outgoing"></i>
                  MacNeil Automotive Parts
                </SpsPageSubtitle>
            </SpsPageTitle>
            </SpsCard>
        `
    };

    render() {
        const { "data-testid": testId } = this.props;
        return (
            <SpsCard>
            <SpsPageTitle data-testid={testId}>
                <i aria-hidden="true" className="sps-icon sps-icon-exclamation-circle red200"></i>
                Cabela's Purchase Order #123456789012
                <SpsPageSubtitle>Cabela's
                  <i aria-hidden="true" className="sps-icon sps-icon-outgoing"></i>
                  MacNeil Automotive Parts
                </SpsPageSubtitle>
            </SpsPageTitle>
            </SpsCard>
        );
    }
}
